// 图像生成相关翻译

export const generation = {
    // 提示词和生成相关
    enterPrompt: '输入您的提示词',
    promptPlaceholder: '例如：山峦上美丽的日落，油画风格，暖色调，详细的风景画...',
    generationCount: '生成数量',
    images: '张图片',
    credits: '积分',
    tip: '提示：描述越详细，生成的图像越接近您的想象',
    generating: '生成中...',
    startGeneration: '开始生成',
    generatedImage: '生成的图像',
    generateSuccess: '生成成功',
    download: '下载',
    downloadError: '下载失败，请稍后重试',
    downloadImageError: '下载失败，请稍后重试',
    
    // 错误处理
    unknownError: '发生未知错误',
    contentPolicyError: '检测到内容政策违规',
    contentPolicySuggestion: '请修改您的提示词以符合内容准则',
    rateLimitMessage: '超出速率限制',
    rateLimitSuggestion: '请稍等片刻再试',
    creditsMessage: '积分不足',
    creditsSuggestion: '请购买更多积分以继续',
    generalSuggestion: '请稍后重试',
    enterPromptError: '请输入提示词',
    generateImageError: '生成图像失败',
    rateLimitError: '超出速率限制，请稍后重试',
    insufficientCreditsError: '积分不足',
    networkError: '网络错误，请检查您的连接',
    
    // 灵感和标签
    inspiration: '灵感',
    inspirationDescription: '从热门主题和风格中获得灵感',
    tags: {
      landscape: '风景',
      portrait: '肖像',
      architecture: '建筑',
      art: '艺术',
      scifi: '科幻',
      nature: '自然',
      animals: '动物',
      creative: '创意'
    },
    
    // AI图像生成
    aiImageGeneration: 'AI图像生成',
    style: '风格',
    aspectRatio: '图片比例',
    styles: {
      realistic: '真实',
      artistic: '艺术',
      anime: '动漫',
      cartoon: '卡通',
      abstract: '抽象'
    },
    styleDescriptions: {
      realistic: '照片级真实图像',
      artistic: '创意艺术风格',
      anime: '日式动漫风格',
      cartoon: '卡通插画风格',
      abstract: '抽象概念艺术'
    },
    sizeDescriptions: {
      squareSmall: '正方形小',
      squareLarge: '正方形大 (1:1)',
      landscape: '横向',
      portrait: '纵向',
      portrait23: '纵向 (2:3)',
      landscape32: '横向 (3:2)',
      portrait34: '纵向 (3:4)',
      landscape43: '横向 (4:3)',
      portrait45: '纵向 (4:5)',
      landscape54: '横向 (5:4)',
      portrait916: '纵向 (9:16)',
      landscape169: '横向 (16:9)',
      ultrawide219: '超宽屏 (21:9)'
    },
    
    // 标签提示文本
    tagPrompts: {
      landscape: '日落时分，雄伟的山脉倒映在晶莹剔透的高山湖泊中，金色的阳光穿透戏剧性的云层，照片级真实感',
      portrait: '一张富有电影感的年轻女性肖像，脸上有雀斑，头发随风飘动，自然光线，背景虚化，35mm镜头拍摄，细节丰富',
      architecture: '充满未来感的对持续发展城市天际线，拥有垂直花园和玻璃摩天大楼，温暖的阳光，鸟瞰图，建筑效果图',
      art: '一幅超现实主义油画，描绘沙漠中挂在树枝上融化的时钟，萨尔瓦多·达利风格，梦幻般的氛围，色彩鲜艳',
      scifi: '雨夜中的赛博朋克街道场景，霓虹灯闪烁的城市，飞行汽车，全息图，湿润的路面反射，银翼杀手风格',
      nature: '一片神秘的古老森林，发光的蘑菇和萤火虫，长满苔藓的岩石，小溪，魔法氛围，奇幻艺术风格',
      animals: '一只彩色树蛙在湿润叶子上的微距特写，水珠，焦点清晰，充满活力的绿色和橙色',
      creative: '双重曝光图像，将人物剪影与星空和森林景观结合，空灵且充满艺术感'
    }
  };
